import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Counter from './components/Counter';
import WhyChooseUs from './components/WhyChooseUs';
import EducationSystem from './components/EducationSystem';
import Teachers from './components/Teachers';
import Seminar from './components/Seminar';
import Gallery from './components/Gallery';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AboutUs />
      <Counter />
      <WhyChooseUs />
      <EducationSystem />
      <Teachers />
      <Seminar />
      <Gallery />
      <ContactCTA />
      <Footer/>
      {/* Diğer componentler buraya gelecek */}
    </div>
  );
}

export default App;
